import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TagInterface } from './definitions/tag-interface';
import { ErrorsInterface } from '../errors/errors-interface';
import { Observable } from 'rxjs';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface TagRemoveResponse {
  Tag: {
    create: {
      output: Array<TagInterface>;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TagRemoveService {
  constructor(private apollo: Apollo) {}

  removeTag(
    tag: TagInterface,
    mutation: DocumentNode
  ): Observable<FetchResult<TagRemoveResponse>> {
    return this.apollo.mutate<TagRemoveResponse>({
      mutation: mutation,
      variables: {
        id: tag.id
      },
    });
  }
}
